export default __webpack_public_path__ + "static/media/references__roc.14cc11f1.jpg";